import * as React from "react";
const SvgFiRrTourVirtual = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tour-virtual_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.047 0 0 2.523 0 6v13.548c0 1.574 1.055 3.057 2.971 4.175a2.02 2.02 0 0 0 2.027.007 1.98 1.98 0 0 0 1.001-1.729V11.323c0-1.12-.628-2.143-1.639-2.667C2.86 7.879 2 6.911 2 6c0-1.932 4.018-4 10-4s10 2.068 10 4c0 .911-.86 1.879-2.36 2.656a3 3 0 0 0-1.639 2.667v10.678c0 .723.375 1.369 1.001 1.729a2.02 2.02 0 0 0 2.027-.007C22.945 22.605 24 21.122 24 19.548V6c0-3.477-5.047-6-12-6M3.44 10.432c.345.18.56.521.56.892l-.021 10.671C3.24 21.564 2 20.673 2 19.549V9.522q.63.49 1.44.91M22 19.548c0 1.124-1.24 2.016-2 2.453V11.323c0-.37.214-.712.56-.892A9.2 9.2 0 0 0 22 9.52zM12 10a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 1c-2.206 0-4 1.794-4 4v2c0 .883.391 1.67 1 2.22V23a1 1 0 1 0 2 0v-3h2v3a1 1 0 1 0 2 0v-3.78c.609-.549 1-1.337 1-2.22v-2c0-2.206-1.794-4-4-4m-1 7c-.551 0-1-.448-1-1v-2c0-1.103.897-2 2-2s2 .897 2 2v2c0 .552-.449 1-1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tour-virtual_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTourVirtual;
